import request from 'sb-request'
import { getState } from 'redux/core'


const fireEvent = (event, products) => {
  const { models: { me: { isLoggedIn } } } = getState()

  if (isLoggedIn) {
    return request.post('rest/event', {
      body: {
        event,
        products,
      },
      withErrorModal: false,
    })
      .then((data) => {
        console.info(`vero ${event}-event fired`)
        return data
      })
  }
}


export default {
  fireEvent,
}
